var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 10 } },
        [
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "BiHeader",
                {
                  attrs: {
                    "header-config": { title: "经营概况" },
                    "tabs-show": "",
                    "item-data": [
                      { desc: "昨日", code: 1 },
                      { desc: "本月", code: 2 },
                    ],
                  },
                  on: { selectTabs: _vm.selectTabs1 },
                },
                [
                  _c(
                    "div",
                    { staticClass: "flex-x mt20 mb10" },
                    _vm._l(_vm.source1, function (item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "flex-y item",
                          staticStyle: {
                            flex: "1",
                            "align-items": "center",
                            "justify-content": "center",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "price" },
                            [
                              _c("Roller", {
                                attrs: {
                                  text: _vm.numToWan(_vm.isType(item)),
                                  transition: 2,
                                },
                              }),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "title" }, [
                            _vm._v(" " + _vm._s(item.name) + " "),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "BiHeader",
                {
                  attrs: {
                    "header-config": { title: "销售出库量" },
                    "tabs-show": "",
                    "item-data": [
                      { desc: "昨日", code: 1 },
                      { desc: "本月", code: 2 },
                    ],
                  },
                  on: { selectTabs: _vm.selectTabs2 },
                },
                [
                  _c(
                    "div",
                    { staticClass: "flex-x mt20 mb10" },
                    _vm._l(_vm.source2, function (item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "flex-y item",
                          staticStyle: {
                            flex: "1",
                            "align-items": "center",
                            "justify-content": "center",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "price" },
                            [
                              _c("Roller", {
                                attrs: {
                                  text: _vm.numToWan(_vm.isType(item)),
                                  transition: 2,
                                },
                              }),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "title" }, [
                            _vm._v(" " + _vm._s(item.name) + " "),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "BiHeader",
                {
                  attrs: {
                    "header-config": {
                      title: "销售单品库存量",
                      text: "截止到昨日",
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "flex-x mt20 mb10" },
                    _vm._l(_vm.source3, function (item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "flex-y item",
                          staticStyle: {
                            flex: "1",
                            "align-items": "center",
                            "justify-content": "center",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "price" },
                            [
                              _c("Roller", {
                                attrs: {
                                  text: _vm.numToWan(_vm.isType(item)),
                                  transition: 2,
                                },
                              }),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "title" }, [
                            _vm._v(" " + _vm._s(item.name) + " "),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("BiHeader", { attrs: { "header-config": { title: "常用功能" } } }, [
        _c(
          "div",
          { staticClass: "flex-x", staticStyle: { "flex-wrap": "wrap" } },
          _vm._l(_vm.usedTable, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "flex-y changyong",
                staticStyle: { "margin-left": "30px", "margin-right": "30px" },
                on: {
                  click: function ($event) {
                    return _vm.goto(item, 2)
                  },
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "iconitem mt20" },
                  [_c("vab-icon", { attrs: { icon: item.icon } })],
                  1
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "font-size": "14px",
                      "margin-top": "20px",
                      "margin-bottom": "20px",
                    },
                  },
                  [_vm._v(" " + _vm._s(item.menuName) + " ")]
                ),
              ]
            )
          }),
          0
        ),
      ]),
      _c("BiHeader", { attrs: { "header-config": { title: "快捷查询" } } }, [
        _c(
          "div",
          { staticClass: "flex-x" },
          [
            _c(
              "el-select",
              {
                staticClass: "mt10 mb10",
                staticStyle: { width: "400px" },
                attrs: {
                  filterable: "",
                  remote: "",
                  "reserve-keyword": "",
                  placeholder: "请输入您想找的菜单名称",
                  "remote-method": _vm.remoteMethod,
                  loading: _vm.loading,
                  "value-key": "value",
                },
                on: {
                  change: function ($event) {
                    return _vm.handleChange($event)
                  },
                },
                model: {
                  value: _vm.value,
                  callback: function ($$v) {
                    _vm.value = $$v
                  },
                  expression: "value",
                },
              },
              _vm._l(_vm.options, function (item) {
                return _c("el-option", {
                  key: item.value,
                  attrs: { label: item.label, value: item },
                })
              }),
              1
            ),
            _vm._l(_vm.searchData, function (itemA, index) {
              return _c("div", { key: index, staticClass: "flex-y mb10" }, [
                _c("div", { staticStyle: { "font-size": "16px" } }, [
                  _vm._v(_vm._s(itemA.name)),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "flex-x",
                    staticStyle: { "flex-wrap": "wrap" },
                  },
                  _vm._l(itemA.child, function (itemB, indexChild) {
                    return _c(
                      "div",
                      {
                        key: indexChild,
                        staticClass: "flex-x childItem",
                        staticStyle: { "align-items": "center" },
                        on: {
                          click: function ($event) {
                            return _vm.goto(itemB, 3)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "iconitem" },
                          [_c("vab-icon", { attrs: { icon: itemB.icon } })],
                          1
                        ),
                        _c("div", { staticClass: "flex-y ml10" }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "14px",
                                "margin-bottom": "5px",
                              },
                            },
                            [_vm._v(" " + _vm._s(itemB.title) + " ")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "text-muted",
                              staticStyle: { "font-size": "12px" },
                            },
                            [_vm._v(" " + _vm._s(itemB.text) + " ")]
                          ),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ])
            }),
          ],
          2
        ),
      ]),
      _c("div", { staticStyle: { height: "calc(100vh - 540px)" } }),
      _c("vab-footer"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }